export default __webpack_public_path__ + "static/media/bathroom-icon.979d2c01.png";